import React from "react";
import Content from "./navigation/Content";
import "./App.css";
import PiePagina from "./components/PiePagina";

function App() {
  return(
  <> 
  <Content />
  <PiePagina/>
  </>);
}

export default App;
